<template>
  <div class="r-add-new-customer">
    <Modal
      :draggable="false"
      footer-hide
      :mask-closable="false"
      :styles="{ top: 0, width: '100%', minWidth: '1440px' }"
      v-model="show"
    >
      <div class="title-box">
        <div class="title">{{ $t("addCustomer.customers") }}</div>
        <div @click="close" class="common-hover iconfont iconguanbi"></div>
      </div>

      <!-- <div class="common-flex common-justify-center new-menu">
        <div
          class="common-hover"
          @click="changeTab(item)"
          v-for="(item, index) in menu"
          :style="[
            item.id == tabId ? { color: '#0A4DCC', fontWeight: 'bold' } : {},
          ]"
          :key="index"
        >
          {{ item.name }}
          <div v-if="item.id == tabId" class="common-line"></div>
        </div>
      </div> -->

      <!-- v-show="tabId == 1" -->
      <div class="common-flex common-flex-wrap customer-box">
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.name') }}<span style="color: red">*</span>
            </div>
            <div style="font-size: 14px; font-weight: 700">
              <input type="text" v-model="customerMsg.custName">
            </div>
          </div>
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.nickname') }}<span style="color: red">*</span>
            </div>
            <div style="font-size: 14px; font-weight: 700">
              <input type="text" v-model="customerMsg.shortName">
            </div>
          </div>
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.gender') }}<span style="color: red">*</span>
            </div>
            <div style="font-size: 14px; font-weight: 700">
              {{customerMsg.genderName}}
            </div>
          </div>
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.height') }}<span style="color: red">*</span>
            </div>
            <div style="font-size: 14px; font-weight: 700" class="common-flex common-align-center">
              <input type="text" style="margin-right:5px" v-model="customerMsg.height">
              {{customerMsg.heightUnitName}}
            </div>
          </div>
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.weight') }}<span style="color: red">*</span>
            </div>
            <div style="font-size: 14px; font-weight: 700" class="common-flex common-align-center">
              <input type="text" style="margin-right:5px" v-model="customerMsg.weight">
              {{customerMsg.weightUnitName}}
            </div>
          </div>
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.phone') }}
            </div>
            <div style="font-size: 14px; font-weight: 700">
              <input type="text" v-model="customerMsg.phone">
            </div>
          </div>
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.email') }}
            </div>
            <div style="font-size: 14px; font-weight: 700">
              <input type="text" v-model="customerMsg.email">
            </div>
          </div>
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.address') }}
            </div>
            <div style="font-size: 14px; font-weight: 700">
              <input type="text" v-model="customerMsg.address">
            </div>
          </div>
          <div class="r-ipt common-flex common-align-center common-justify-between">
            <div class="title">
              {{ $t('customer.basicList.DOB') }}
            </div>
            <div style="font-size: 14px; font-weight: 700">
              <input type="text" v-model="customerMsg.birthdate">
            </div>
          </div>
      </div>

      <div class="common-flex common-justify-center options">
        <div class="back options-btn common-hover" @click="close">{{ $t("saveItems.back") }}</div>
        <div class="save options-btn common-hover" @click="edit">{{ $t("saveItems.edit") }}</div>
      </div>
    </Modal>
  </div>
</template>

<script>
import rText from "./r-text";
// import rSelect from "./r-select";
// import rIptSelect from "./r-ipt-select";
// import rIptText from "./r-ipt-text";
export default {
  name: "r-add-new-customer",
  data() {
    return {
      show: true,
      tabId: 1,
      styleIndex: 0,
      style: [
        {
          label: "Body Type",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Left Shoulder",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Right Shoulder",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Shoulder Blade",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Back",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Concave",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Chest",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Stomach",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Hip",
          type: "text",
          textvalue: "测试",
        },
      ],
      menu: [
        {
          id: 1,
          name: this.$t("addCustomer.basic"),
        },
        {
          id: 2,
          name: this.$t("addCustomer.style"),
        },
        {
          id: 3,
          name: this.$t("addCustomer.body"),
        },
      ],
      basicList: [
        {
          label: this.$t('customer.basicList.name'),
          type: "text",
          textvalue: "",
        },
        {
          label: this.$t('customer.basicList.nickname'),
          type: "text",
          textvalue: "",
        },
        {
          label: this.$t('customer.basicList.gender'),
          type: "text",
          textvalue: "",
        },
        {
          label: this.$t('customer.basicList.height'),
          type: "text",
          textvalue: "",
        },
        {
          label: "Weight",
          type: "text",
          textvalue: "",
        },
        {
          label: "Phone",
          type: "text",
          textvalue: "",
        },
        {
          label: "Email",
          type: "text",
          textvalue: "",
        },
        {
          label: "Address",
          type: "text",
          textvalue: "",
        },
        {
          label: "DOB",
          type: "text",
          textvalue: "",
        },
      ],
      bodyList: [
        {
          label: "Waist",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Hip",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Thigh",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "U Rise",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Front Rise Height",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Back Rise Height",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Knee",
          type: "text",
          textvalue: "测试",
        },
        {
          label: "Bottom",
          type: "text",
          textvalue: "测试",
        },
      ],
    };
  },
  components: {
    // rIpt,
    // rSelect,
    // rIptSelect,
    // rIptText,
    rText,
  },
  watch: {
    detailsShow: {
      handler(newold, oldval) {
        this.show = newold;
      },
      immediate: true,
    },
  },
  props: {
    detailsShow: Boolean,
    customerMsg:[String,Object]
  },
  methods: {
    // 点击编辑
    edit(){
      if(this.customerMsg.custName==''){
        this.$Message.error(this.$t('customer.saveTips.Name'))
      }else if(this.customerMsg.shortName==''){
        this.$Message.error(this.$t('customer.saveTips.Nickname'))
      }else if(this.customerMsg.height==''){
        this.$Message.error(this.$t('customer.saveTips.Height'))
      }else if(this.customerMsg.weight==''){
        this.$Message.error(this.$t('customer.saveTips.Weight'))
      }else{
        this.$emit('editMsg')
      }
    },
    // 关闭弹框
    close() {
      this.$emit("handlerDetails");
    },
    // 修改某一项风格
    changeStyleChild(e) {
      this.style[this.styleIndex].chooseId = e;
    },
    // 选择风格
    chooseStyle(e) {
      this.styleIndex = e;
    },
    // 选择不同分类
    changeTab(e) {
      this.tabId = e.id;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-content {
  border-radius: 0;
}
/deep/.ivu-modal-body {
  padding: 0;
}
.style-name {
  position: relative;
  .triangle {
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    margin-right: auto;
    margin-left: auto;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 4px solid #fff;
  }
}
.r-ipt{
    width: 350px;
    padding-bottom: 12px;
    border-bottom: 1px solid #B4BAC3;
    .title{
        // width: 170px;
        flex-basis: 50%;
        line-height: 32px;

    }
    input{
        width: 170px;
        // text-align: right;
        height: 32px;
        line-height: 32px;
    }
}
.customer-box {
  width: 1130px;
  margin: 60px auto 0;
  > div {
    margin-bottom: 40px;
    margin-right: 40px;
  }
  > div:nth-child(3n + 3) {
    margin-right: 0;
  }
}
.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;
  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}
.options {
  position: relative;
  // width: 1130px;
  margin: 20px auto;
  padding-bottom: 25px;
  .options-btn {
    width: 116px;
    height: 40px;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    background: #b5bac4;
    margin: 0 7px;
  }
  .save {
    background: #081938;
  }
}
.new-menu {
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
  text-align: center;
  color: #525e73;
  line-height: 16px;
  padding-top: 20px;
  > div {
    margin: 0 100px;
    position: relative;
    padding-bottom: 12px;
    // margin-right: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-customer-details.vue